class CustomDropdown extends HTMLElement {
    constructor() {
        super();
        this.content = this.querySelector('.content');
        this.contentHeight = this.content.querySelector('.text').offsetHeight;
        this.addEventListener('click', this.toggle.bind(this));
        window.addEventListener('resize', this.initValueHeight.bind(this));
    }

    toggle() {
        console.log(this.contentHeight);
        this.classList.toggle('active');
        this.changeHeight();
        
    }

    initValueHeight() {
        this.contentHeight = this.content.querySelector('.text').offsetHeight;
    }
    changeHeight() {
      
        if(this.classList.contains('active')) {
            this.content.style.setProperty('--maxHeight', this.contentHeight + 'px');
        }else {
            this.content.style.setProperty('--maxHeight', 0 +'px');
        }
    }
}

customElements.define('custom-dropdown', CustomDropdown);
